import React from 'react';
import styled from 'styled-components';
import { Building, Users, Target, Calendar, MapPin, Award, TrendingUp, Globe } from 'lucide-react';
import ContentLayout from '../../Common/Component/ContentLayout';

const Container = styled.div`
  width: 100%;
`;

const HeroSection = styled.div`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 60px 40px;
  border-radius: 12px;
  text-align: center;
  margin-bottom: 40px;
`;

const HeroTitle = styled.h1`
  font-size: 36px;
  font-weight: 700;
  margin: 0 0 20px 0;
`;

const HeroSubtitle = styled.p`
  font-size: 18px;
  opacity: 0.9;
  margin: 0 0 30px 0;
  line-height: 1.6;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
`;

const CompanySlogan = styled.div`
  font-size: 24px;
  font-weight: 600;
  opacity: 0.95;
  margin-top: 20px;
`;

function About() {
  return (
    <ContentLayout 
      title="회사소개"
      subtitle="AntsMarket과 함께 더 나은 내일을 만들어가세요"
    >
      <Container>
        <HeroSection>
          <HeroTitle>AntsMarket</HeroTitle>
          <HeroSubtitle>
            작은 개미들이 모여 큰 힘을 만들어내듯,<br/>
            우리는 작은 아이디어들을 모아 혁신적인 마켓플레이스를 만들어갑니다.
          </HeroSubtitle>
          <CompanySlogan>"작은 것들이 만드는 큰 변화"</CompanySlogan>
        </HeroSection>
      </Container>
    </ContentLayout>
  );
}

export default About;
